import { render, staticRenderFns } from "./FundsReportsView.vue?vue&type=template&id=08af59cd&scoped=true&"
import script from "./FundsReportsView.vue?vue&type=script&lang=ts&"
export * from "./FundsReportsView.vue?vue&type=script&lang=ts&"
import style0 from "./FundsReportsView.vue?vue&type=style&index=0&id=08af59cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af59cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
